###
Gridspy Live Data

Copyright (c) 2012 Gridspy Ltd
All Rights Reserved
###

if not window.gs?
  window.gs = {}

gs = window.gs
### ===================== LIVE DATA ===================== ###

gs.live_data = do () ->
  #socket_port = 3451
  #tried_direct = false
  curr_session_key = null
  update_func = null
  connected = false
  curr_hub_id = null
  
  hostname = window['socket_io_hostname']
  unless hostname?
    hostname = 'http://localhost'

  # Socket Connections
  # ---------------------
  # socket.io specific code
  socket = io.connect hostname

  socket.on 'connect', () ->
    console?.log "Socket.io Connected"
  
  socket.on 'connecting', (transport_type) ->
    console?.log "Connecting #{transport_type}..."
  
  socket.on 'connect_failed', ->
    console?.log "Live data connection failed"# (port #{socket_port})"
    #try_other_port()
    
  socket.on 'error', ->
    console?.log "Socket.io reported a generic error"
    gs.done_loading("live_conn")
    gs.bindings.show_message "Live Data Error.", "Could not connect to Gridspy Live Data server. Live data, setup and some other features will not function", "error"
    #try_other_port()
    
  #Dashboard specific events ... 
  socket.on 'gs_connect', ->
    connected = true
    gs.done_loading("live_conn")
    console?.log "Connected with GridSrv"
    set_session(curr_session_key)
    do_subscribe()

  # This is received after a successful auth following set_session.
  socket.on 'auth_success', (data) ->
    #console?.log 'Successful Auth: ', data
    gs.installer?.update_hubs data.hubs
    if curr_hub_id?
      set_hub curr_hub_id

  socket.on 'auth_fail', (data) ->
    console?.log 'Failed Auth: ', data
  
  socket.on "session_msg", (role_name, type, args) -> 
    if role_name == "cfg" and gs.installer?
      #console?.log "session_msg: cfg - ", type, args
      if type == "diag_status"
        gs.installer.apply_state args...
      else if type == "diag_radio"
        gs.installer.apply_radio args...
      else if type == "cfg_saved"
        [msg] = args
        console?.log "Config saved (2)", msg
        gs.installer.save_done msg
      else if type == "node_list"
        [nodes] = args
        gs.installer.update_hubs nodes
        gs.done_loading("inst_nodes")

      else if type == "auth_fail"
        gs.installer?.auth_fail()
        console?.log 'Failed Auth: ', args    
      else if type == "gs_config"
        [config] = args
        console?.log "Config from server", config
        gs.installer?.apply_input_config config
      else if type == "gs_config_err"
        [err] = args
        gs.installer?.cfg_fail()
        console?.log "Error getting config from server", err
      else
        console?.log "session_msg: Unknown cfg message", type, args
    else 
      console?.log "session_msg: Unknown role ", role_name, type, args
    
  socket.on 'diag_status', (state) ->
    gs.installer?.apply_state state

  socket.on 'cfg_saved', (msg) -> 
    console?.log "Config saved", msg
    gs.installer?.save_done(msg)
  
  socket.on "session_msg_fail", (error) ->
    console?.log "session_msg_fail", error
  
  socket.on 'live', (data) ->
    # data is a list of pks, with a fresh list of readings for each one.
    if gs.bindings?.data_mgr?
      gs.bindings.data_mgr.notify_new_seconds(data)

    gs.done_loading("live_data")
    if update_func?
      for own pk, samples_list of data

        unless samples_list.length?
          samples_list = [samples_list]

        old_format =
          'hist' : samples_list
          'latest' : samples_list[samples_list.length - 1]
          'pk':pk
          'num_new':samples_list.length

        update_func(old_format)

  socket.on 'dash_update', (data) ->
    if data['type'] == 'data'
      if update_func?
        update_func(data)
      update_realtime_new(data)

  ### ===================== Live data management and subscriptions. ===================== ###

  registered_buildings = []
  to_watch = window['buildings_to_watch']
  if to_watch?
    registered_buildings = registered_buildings.concat(to_watch)
  
  do_subscribe = ->
    socket.emit "subscribe", registered_buildings

  set_session = (session_key) ->
    curr_session_key = session_key
    if session_key? and session_key != "" and connected
      socket.emit 'set_session', session_key
      socket.emit "session_msg", "cfg", "get_nodes", []
  
    
  return {
    # Each feed is called like so feed(pk, latest_reading) whenever a new reading comes in for a sensor.
    connect_building: (tag) ->
      if tag not in registered_buildings
        gs.show_loading("live_data")
        socket.emit "subscribe", [tag]
        registered_buildings.push(tag)
        console?.log "Now subscribed to ", registered_buildings
    send_keepalive: -> socket.emit "liveheartbeat", registered_buildings
    set_hub: (hub_id) ->
      curr_hub_id = hub_id
      return unless connected
      socket.emit "session_msg", "cfg", "set_id", [hub_id]
    inst_refresh_nodes: () ->
      if curr_session_key? and curr_session_key != "" and connected
        socket.emit "session_msg", "cfg", "get_nodes", []
        gs.show_loading("inst_nodes")

    save_cfg: (cfg) -> socket.emit "session_msg", "cfg", "cfg_save", [cfg]
    set_session: set_session
    set_update_func: (func) -> update_func = func
    connected: -> connected

  }

#$(document).ready -> 
#  gs.live_data.register_feed(->gs.bindings.liveDataChanged());
